export const GA_QUEUE_ID = 'ga';
export const GA_VENDOR_ID = 'google';
